import { useEffect } from 'react';
import { useDetectDevice } from './useDetectDevice';

const checkLoadCSSDuplicated = (href) => {
  if (window !== 'undefined') {
    const styleSheets = Array.from(document.head.getElementsByTagName('link'));

    if (styleSheets.length) {
      const styleEleLast = styleSheets.slice(-1)[0];

      return styleEleLast.getAttribute('href') === href;
    }
  }

  return false;
};

const useLoadCSS = (href) => {
  const { isDesktop } = useDetectDevice();

  useEffect(() => {
    if (!isDesktop && href && !checkLoadCSSDuplicated(href)) {
      var link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = "this.onload=null;this.rel='stylesheet'";

      document.head.appendChild(link);
    }
  }, [href, isDesktop]);
};

export default useLoadCSS;
